import React, { Component } from "react";
import { Pagination, SearchBar, Table, Warning } from "@culturehq/components";
import client from "@culturehq/client";

import { t, Trans } from "app/utils";
import rsvpResponseTypes from "constants/rsvpResponseTypes";

import Attendee from "./Attendee";

const responseOptions = [
  { label: t("View All"), value: null },
  ...rsvpResponseTypes
];

const NoRSVPs = ({ search }) => (
  <Warning>
    {search
      ? t(`No results found for ${search}`)
      : t("No attendees to show.")}
  </Warning>
);

class AttendeeList extends Component {
  state = {
    rsvps: [],
    search: "",
    pagination: {},
    responseType: null
  };

  componentDidMount() {
    this.fetchRsvps(1);
  }

  handleFilterChange = selected => {
    this.setState({ responseType: selected.value }, () => this.fetchRsvps(1));
  };

  handleSearch = async query => {
    const { event: { id: eventId } } = this.props;
    const { rsvps } = await client.eventAutocompleteRsvps({ query, eventId });

    this.setState({ rsvps, pagination: null, responseType: null });
  };

  handleSearchChange = search => {
    this.setState({ search, rsvps: null, pagination: null });

    if (!search) {
      this.fetchRsvps(1);
    }
  };

  handleRsvpUpdate = update => {
    const { onRefreshInvitations } = this.props;
    onRefreshInvitations();

    this.setState(({ rsvps }) => ({
      rsvps: rsvps.map(rsvp => (rsvp.id === update.id ? update : rsvp))
    }));
  };

  fetchRsvps = async page => {
    const { event: { id: eventId } } = this.props;
    const { responseType } = this.state;

    const { rsvps, pagination } = await client.listEventRsvps({ eventId, responseType, page });

    this.setState({ rsvps, pagination });
  };

  render() {
    const { event, onEventUpdate } = this.props;
    const { rsvps, responseType, search, pagination } = this.state;

    const { rsvpBreakdown } = event;

    return (
      <div className="AttendeesTable row">
        <div className="col-sm-12 AttendeesTable--search">
          <SearchBar
            onSearch={this.handleSearch}
            onSearchChange={this.handleSearchChange}
            placeholder={t("Search Guests")}
          />
        </div>

        {!search && (
          <div className="col-sm-12">
            <div className="row">
              <ul className="nav nav-tabs">
                {responseOptions.map(option => {
                  const activeClass = option.value === responseType ? "active" : "inactive";
                  let count = rsvpBreakdown && rsvpBreakdown[option.value];

                  // All Tab
                  if (!option.value) {
                    count = rsvpBreakdown && rsvpBreakdown.all;
                  }

                  return (
                    <li key={option.value} className={activeClass}>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a onClick={() => this.handleFilterChange(option)}>
                        {option.label}
                        {count > 0 && ` (${count})`}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}

        <div className="col-sm-12">
          <Table>
            <thead>
              <tr>
                <th />
                <th><Trans>Name</Trans></th>
                <th><Trans>RSVP</Trans></th>
              </tr>
            </thead>
            <tbody>
              {rsvps && rsvps.map(rsvp => (
                <Attendee
                  key={rsvp.id}
                  rsvp={rsvp}
                  event={event}
                  onRsvpUpdate={this.handleRsvpUpdate}
                  onEventUpdate={onEventUpdate}
                />
              ))}
            </tbody>
          </Table>

          {rsvps && rsvps.length < 1 && (
            <NoRSVPs search={search} responseType={responseType} />
          )}

          {pagination && (
            <Pagination {...pagination} onClick={this.fetchRsvps} />
          )}
        </div>
      </div>
    );
  }
}

export default AttendeeList;
